import {
    Wand2,
    Palette,
  } from "lucide-react";
  
  export const IA_DESIGNER_UPSELL_MODAL_CONTENT = {
    title: "Diseñador de imágenes con IA",
    introText: (
      <>
        Estamos desarrollando un{" "}
        <span className="font-semibold text-primary bg-primary/5 px-1.5 py-0.5 rounded-md">
          diseñador de imágenes con IA
        </span>{" "}
        que transformará la creación visual para tus campañas de marketing digital.
      </>
    ),
    highlightText: "¡Próximamente!",
    highlightDescription: "Diseña imágenes impactantes sin necesidad de ser un experto.",
    features: [
      {
        icon: <Wand2 className="h-5 w-5 text-primary" />,
        title: "Generación de imágenes con IA",
        description: "Crea imágenes profesionales a partir de descripciones de texto, perfectas para cualquier campaña.",
      },
      {
        icon: <Palette className="h-5 w-5 text-primary" />,
        title: "Adaptación a tu marca",
        description: "Genera imágenes que respetan automáticamente los colores, estilos y elementos de tu marca.",
      },
    ],
  };

  
  